import { unreadonly } from '../../../types/unreadonly';
import type { TableFilterBase } from '../TableFilter';
import { filterOperators } from '../operators';

const numberFilterOperators = unreadonly([
  ...filterOperators.number,
  ...filterOperators.empty,
  ...filterOperators.column,
  ...filterOperators.color,
] as const);

export type NumberFilterOperator = (typeof numberFilterOperators)[number];

export type NumberTableFilter = TableFilterBase & {
  type: 'number';
  compact: boolean;
};

type NumberFilterOptions = {
  compact?: boolean;
};

export const createNumberFilter = (
  options?: NumberFilterOptions,
): NumberTableFilter => ({
  type: 'number',
  operators: numberFilterOperators,
  compact: options?.compact ?? false,
});
